export class xmlToJsonTF{

    convertXmlToJson(inputXml){
        
        const parseString = require('xml2js').parseString;
        const xml = inputXml;
        let resultado;
        parseString(xml, (err, result) => {
            resultado= result;
        });
        return resultado;
    }

    replaceCharXml(inputXml){
        let gt = /&gt;/gi;        
        let lt = /&lt;/gi;
        let quot = /&quot;/gi;
        let resultado = inputXml.replace(gt,">");
        resultado = resultado.replace(lt,"<");
        resultado = resultado.replace(quot,"'");

        return resultado;
    }
}
